// @flow
import _ from 'lodash'
import React, { Component } from 'react'
import Checkbox from '../controls/Checkbox'
import styled from 'styled-components'
import { RowLabel } from './Form'
import { translateFunc, translations } from '../../shared/localize'
import type { GroupedHeaders } from '../controls/groupHeaders'

const ColumnsWrapper = styled.div`
  display: flex;
  margin-right: -25px;
`
const Column = styled.div`
  padding-right: 25px;
  max-width: 200px;
  min-width: 130px;
`
const Item = styled.div`
  margin-bottom: 8px;
`
const Label = styled.div`
  padding: 3px 0 10px;
  font-size: 12px;
  color: gray;
`

type Props = {|
  groupedFields: GroupedHeaders,
  selectedFields: Array<string>,
  disabled?: boolean,
  onChange: Function
|}

const t = translateFunc(translations.statistics)
const headerT = translations.table_headers

export default class FilterFields extends Component<Props> {
  render() {
    const { groupedFields, selectedFields, disabled, onChange } = this.props
    return (
      <div>
        <RowLabel>{t('statistic_fields')}</RowLabel>
        <ColumnsWrapper>
          {_.map(groupedFields, (fields, fieldType: string) => {
            if (_.isEmpty(fields)) return null
            return (
              <Column key={fieldType}>
                <Label>{t(fieldType)}</Label>
                {_.map(fields, (field, index) => (
                  <Item key={`field_${index}`}>
                    {!_.isEmpty(field) && (
                      <Checkbox
                        className={`t-FilterCheckbox__${field}`}
                        checked={_.includes(selectedFields, field)}
                        liteDisableMode
                        disabled={disabled}
                        onChange={(checked) => onChange(field, checked)}
                        label={headerT[field]}
                        compact
                        alignBaseline
                      />
                    )}
                  </Item>
                ))}
              </Column>
            )
          })}
        </ColumnsWrapper>
      </div>
    )
  }
}
